<template>
    <v-container class="login-page-wrapper w-100 h-100" ma-0 pa-0>
        <div class="d-flex h-100">
            <v-col class="h-100 p-0 carousel-wrapper" cols="12" md="5" sm="5">
                <div class="d-flex flex-column h-100 mx-auto justify-content-center align-items-center">
                    <div class="mb-5">
                        <v-img class="carousel-wrapper-logo" src="/images/britannia-logo.png" width="200px"></v-img>
                    </div>
                    <slot name="formLinks">
                        <div class="form-links">
                            <h4>Secure Sign Forms</h4>
                            <ul class="secure-sign-forms__list">
                                <li>
                                    <a href="/ssf/patient-discontinuation-form">Patient Discontinuation Form</a>
                                </li>
                                <li>
                                    <a href="/ssf/pharmacy-registration-form">Pharmacy Registration Form</a>
                                </li>
                                <li>
                                    <a href="/ssf/patient-transfer-form-from-brand-to-denzapine"
                                        >Patient Transfer Form from Other Brand to Denzapine</a
                                    >
                                </li>
                                <li>
                                    <a href="/ssf/patient-registration-form">Patient Registration Form</a>
                                </li>
                                <li>
                                    <a href="/ssf/prescriber-registration-form">Prescriber Registration Form</a>
                                </li>
                                <li>
                                    <a href="/ssf/website-user-registration-form">Website User Registration Form</a>
                                </li>
                                <li>
                                    <a href="/ssf/off-label-agreement-form">Off-Label Agreement Form</a>
                                </li>
                                <li>
                                    <a href="/ssf/re-challenge-request-form">Re-challenge Request Form</a>
                                </li>
                            </ul>
                        </div>
                    </slot>
                </div>
            </v-col>
            <v-col class="h-100 p-0 carousel-component" cols="12" md="7" sm="7">
                <slot name="loginForm">
                    <login-form-component :post-login-route="postLoginRoute"></login-form-component>
                </slot>
            </v-col>
        </div>
    </v-container>
</template>

<script>
import LoginFormComponent from './LoginFormComponent';

export default {
    components: {
        LoginFormComponent,
    },
    props: {
        postLoginRoute: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">
.form-links {
    margin-left: 100px;
}

h4 {
    color: white;
    font-size: 1.5rem;
}

ul {
    list-style-type: decimal;
    padding: 15px;
    margin: 0;
    color: white;

    li {
        color: white;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
        margin: 0 0 10px 0;

        a {
            color: white;
            text-decoration: none;
            text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
        }

        &:hover {
            a {
                text-decoration: underline;
            }
        }
    }
}
</style>
